import { render } from "./TaiXeChecklist.vue?vue&type=template&id=5fbb5fa4&scoped=true"
import script from "./TaiXeChecklist.vue?vue&type=script&lang=js"
export * from "./TaiXeChecklist.vue?vue&type=script&lang=js"

import "./TaiXeChecklist.vue?vue&type=style&index=0&id=5fbb5fa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbb5fa4"]])

export default __exports__